export default [
  {
    leistungstext: "Künftige Bedingungsverbesserungen gelten automatisch",
    infoText:
      "Sie profitieren automatisch von Leistungsverbesserungen, die wir ohne Beitragserhöhung im ausgewählten Produkt vornehmen.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Gebrauch von Elektrofahrrädern",
    infoText:
      "Wir versichern die Haftpflicht aus dem Besitz und Gebrauch von Elektrofahrrädern genauso wie die von Fahrrädern.",
    leistungen: ["Ja", "Ja", "Ja"],
  },
  {
    leistungstext: "Versicherungspflichtige motorisierte Flugmodelle (z. B. Drohnen und Quadrokopter)",
    infoText: "Die Haftpflicht für Flugmodelle ist bis 250 g oder 5 kg mitversichert.",
    leistungen: ["bis 250 g", "bis 250 g", "bis 5 kg"],
  },
  {
    leistungstext: "Forderungsausfall-Deckung",
    infoText:
      "Sind Sie selbst Geschädigter und der Schadenverursacher kann den Schaden nicht begleichen, leisten wir unter bestimmten Voraussetzungen für Ihren Forderungsausfall.",
    leistungen: ["ab 2.000 € Mindestschadenhöhe", "Ja", "Ja"],
  },
  {
    leistungstext: "Fremde berufliche Schlüssel",
    infoText:
      "Wir ersetzen im Rahmen der gesetzlichen Haftpflichtansprüche auch die Auswechslung von Schlössern und Schließanlagen bei beruflich anvertrauten Schlüsseln entsprechend der angegebenen Summen.",
    leistungen: ["bis 20.000 €", "bis 100.000 €", "Ja"],
  },
  {
    leistungstext: "Selbstgenutztes Wohnhaus mit bis zu 4 Wohneinheiten",
    infoText:
      "Wir ersetzen im Rahmen der gesetzlichen Haftpflichtansprüche auch die Auswechslung von Schlössern und Schließanlagen bei beruflich anvertrauten Schlüsseln entsprechend der angegebenen Summen.",
    leistungen: ["Nein", "Ja", "Ja"],
  },
  {
    leistungstext: "Eltern und Großeltern des Versicherungsnehmers",
    infoText:
      "Haftpflichtansprüche Dritter gegen Ihre Eltern und Großeltern sind mit abgesichert, wenn diese in Ihrem Haushalt oder einer Pflegeeinrichtung leben.",
    leistungen: ["Nein", "Ja", "Ja"],
  },
  {
    leistungstext: "Nicht deliktfähige Kinder und Personen",
    infoText:
      "Auch wenn nicht deliktfähige Kinder und Personen für Schäden nicht haftbar gemacht werden können, leisten wir Schadenersatz entsprechend der angegebenen Summen.",
    leistungen: ["10.000 €", "Ja", "Ja"],
  },
  {
    leistungstext: "Nebentätigkeit bis Jahresumsatz von",
    infoText:
      "Haftpflichtansprüche aus bestimmten selbständigen und/oder freiberuflichen Nebentätigkeiten sind im Rahmen der angegebenen Summe mit abgesichert. Dies beschränkt sich auf<ul><li>Alleinunterhalter</li><li>Annahmestellen für Sammelbesteller</li><li>Änderungsschneiderei, Stickerei</li><li>Daten- und Texterfassung</li><li>Fotografen</li><li>Frisöre</li><li>Kunsthandwerker (z. B. Töpfer)</li><li>Lehrer (nebenberuflich, z. B. Nachhilfe oder Musiklehrer)</li><li>Markt- und Meinungsforschung</li><li>Tierbetreuung</li><li>Trageberater</li><li>Übersetzer</li><li>Verkauf auf Flohmärkten und Basaren</li><li>Vertrieb von Kosmetika, Haushaltsartikeln und Schmuck</li></ul>Der Versicherer ist von der Verpflichtung zur Leistung frei, wenn der Umsatz aus dieser Tätigkeit in den letzten 12 vollen Monaten vor Schadeneintritt den angegeben Betrag übersteigt.",
    leistungen: ["Nein", "6.000 €", "22.000 €"],
  },
  {
    leistungstext: "Schäden durch im europäischen Ausland gemieteten Kfz (Mallorcadeckung)",
    infoText:
      "Wir bieten ergänzenden Versicherungsschutz auch für Kfz-Haftpflichtschäden bei Mietwägen innerhalb Europas.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
];
